import type { SynthStyle } from "@client/utils/synth/types";

export const SYNTH_MASTER_GAIN = 0.16;

export const SYNTH_LOWPASS_HZ = 4_200;

export const SYNTH_DEFAULT_ATTACK = 0.008;

export const SYNTH_GLIDE_IN = 0.04;

export const SYNTH_SILENCE = 0.0001;

export const SYNTH_GLASS: SynthStyle = {
	wave: "sine",
	attack: 0.003,
	durationScale: 2,
	minDuration: 0.14,
	maxDuration: 1.4,
	octave: 1,
	partials: [
		{ ratio: 2.756, gain: 0.22, length: 0.45 },
		{ ratio: 5.404, gain: 0.06, length: 0.2 },
	],
	gain: 0.9,
};

export const SYNTH_WOOD: SynthStyle = {
	wave: "sine",
	attack: 0.002,
	durationScale: 0.9,
	minDuration: 0.07,
	maxDuration: 0.28,
	octave: 0.5,
	partials: [{ ratio: 4, gain: 0.45, length: 0.18 }],
	gain: 1.5,
};
